import {
  Avatar,
  Card,
  Col,
  List,
  Row,
  Select,
  Skeleton,
  Typography,
} from "antd";
import * as React from "react";
import { useEffect, useState } from "react";
import "./order-report.less";

import { setLoading } from "states/global-value/global-value.slice";

import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Column } from "@ant-design/charts";
import { Content } from "antd/lib/layout/layout";
import Title from "antd/lib/typography/Title";
import { selectCurrentBranch } from "states/branch/branch.slice";
import {
  GetOrderReportChartModel,
  OrderReportChartModel,
  OrderReportTopProductModel,
  OrderReportType,
  OrderTotalReportModel,
} from "states/order-report/order-report.models";
import {
  getStatisticalOverview,
  orderReportType,
} from "states/order-report/order-report.api";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { ProductName } from "shared/components/product/product-name";
export interface IOrderReportProps {}

export function OrderReport(props: IOrderReportProps) {
  const dispatch = useDispatch();
  const currentBranch = useSelector(selectCurrentBranch, shallowEqual);
  const [selectOrderType, setOrderType] = useState<OrderReportType>();
  const [orderReport, setOrderReport] = useState<OrderTotalReportModel>();
  const [reportChartOrder, setReportChartOrder] = useState<
    OrderReportChartModel[]
  >([] as OrderReportChartModel[]);

  const loadingTotalOrder = async () => {
    dispatch(setLoading(true));
    try {
      const res = await getStatisticalOverview(currentBranch.id);
      setOrderReport(res.data);
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  };
  const loadingReportChartOrder = async () => {
    try {
      dispatch(setLoading(true));
      const res = await orderReportType({
        orderReportType: selectOrderType,
        branchId: currentBranch.id,
      } as GetOrderReportChartModel);
      setReportChartOrder(res.data);
      dispatch(setLoading(false));
    } catch (e) {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    loadingTotalOrder();
    loadingReportChartOrder();
  }, [currentBranch]);
  const renderProduct = (model: OrderReportTopProductModel) => {
    return (
      <List.Item>
        <Skeleton avatar title={false} loading={false} active>
          <List.Item.Meta
            avatar={
              <Avatar
                src={
                  model.product.images?.length > 0
                    ? redirectFileLocalUrl(model.product.images[0])
                    : ""
                }
              >
                {model.product.images?.length === 0
                  ? model.product?.name.charAt(0)
                  : ""}
              </Avatar>
            }
            title={
              <>
                <ProductName product={model.product} />
                <p key="list-loadmore-edit">{model.totalOrder} đơn hàng</p>
              </>
            }
          />
        </Skeleton>
      </List.Item>
    );
  };
  const bestSellerProduct = () => {
    let html = [];
    switch (selectOrderType) {
      case OrderReportType.Today:
        for (let [key, value] of Object.entries(
          orderReport?.today?.products ?? {}
        )) {
          html.push(renderProduct(value));
        }
        break;
      case OrderReportType.Yesterday:
        for (let [key, value] of Object.entries(
          orderReport?.yesterday?.products ?? {}
        )) {
          html.push(renderProduct(value));
        }
        break;
      case OrderReportType.Month:
        for (let [key, value] of Object.entries(
          orderReport?.month?.products ?? {}
        )) {
          html.push(renderProduct(value));
        }
        break;
      case OrderReportType.Week:
        for (let [key, value] of Object.entries(
          orderReport?.week?.products ?? {}
        )) {
          html.push(renderProduct(value));
        }
        break;
      case OrderReportType.LastMonth:
        for (let [key, value] of Object.entries(
          orderReport?.lastMonth?.products ?? {}
        )) {
          html.push(renderProduct(value));
        }
        break;
    }
    return html;
  };
  useEffect(() => {
    loadingReportChartOrder();
  }, [selectOrderType]);
  const config = {
    data: reportChartOrder?.map((m) => {
      return {
        type: m.label,
        totalAmount: Object.values(m.totals)[0],
        orderTotal: `${Object.keys(m.totals)[0]} đơn hàng`,
      };
    }),
    xField: "type",
    yField: "totalAmount",
    xLabel: "t  ",
    xAxis: { label: { autoRotate: false } },
    scrollbar: true,
    seriesField: "orderTotal",
    isGroup: true,
    meta: {
      type: { alias: "" },
      sales: { alias: "₫" },
    },
  };
  return (
    <div className="appointment-report">
      <Content className="p-4">
        <Row gutter={16}>
          <Col className="gutter-row" span={6}>
            {currentBranch.name}
          </Col>
        </Row>
        <Row
          gutter={[8, 8]}
          justify="space-around"
          className="pt-4"
          align="middle"
        >
          <Col className="gutter-row" flex={1}>
            <Card
              className="text-center cursor-pointer"
              onClick={() => {
                setOrderType(OrderReportType.Today);
              }}
            >
              <div>
                <Title level={5}>Hôm nay</Title>
              </div>
              <div>
                <Title level={4}>
                  {orderReport?.today?.totalOrder} đơn hàng
                </Title>
              </div>
              <div>
                <Typography.Text>
                  {formatMoney(orderReport?.today?.totalAmount)}
                </Typography.Text>
              </div>
            </Card>
          </Col>
          <Col className="gutter-row" flex={1}>
            <Card
              className="text-center cursor-pointer"
              onClick={() => {
                setOrderType(OrderReportType.Yesterday);
              }}
            >
              <div>
                <Title level={5}>Hôm qua</Title>
              </div>
              <div>
                <Title level={4}>
                  {orderReport?.yesterday?.totalOrder} đơn hàng
                </Title>
              </div>
              <div>
                <Typography.Text>
                  {formatMoney(orderReport?.yesterday?.totalAmount)}
                </Typography.Text>
              </div>
            </Card>
          </Col>
          <Col className="gutter-row" flex={1}>
            <Card
              className="text-center cursor-pointer"
              onClick={() => {
                setOrderType(OrderReportType.Week);
              }}
            >
              <div>
                <Title level={5}>7 ngày gần đây</Title>
              </div>
              <div>
                <Title level={4}>
                  {orderReport?.week?.totalOrder} đơn hàng
                </Title>
              </div>
              <div>
                <Typography.Text>
                  {formatMoney(orderReport?.week?.totalAmount)}
                </Typography.Text>
              </div>
            </Card>
          </Col>
          <Col className="gutter-row" flex={1}>
            <Card
              className="text-center cursor-pointer"
              onClick={() => {
                setOrderType(OrderReportType.Month);
              }}
            >
              <div>
                <Title level={5}>Tháng này</Title>
              </div>
              <div>
                <Title level={4}>
                  {orderReport?.month?.totalOrder} đơn hàng
                </Title>
              </div>
              <div>
                <Typography.Text>
                  {formatMoney(orderReport?.month?.totalAmount)}
                </Typography.Text>
              </div>
            </Card>
          </Col>
          <Col className="gutter-row" flex={1}>
            <Card
              className="text-center cursor-pointer"
              onClick={() => {
                setOrderType(OrderReportType.LastMonth);
              }}
            >
              <div>
                <Title level={5}>Tháng trước</Title>
              </div>
              <div>
                <Title level={4}>
                  {orderReport?.lastMonth?.totalOrder} đơn hàng
                </Title>
              </div>
              <div>
                <Typography.Text>
                  {formatMoney(orderReport?.lastMonth?.totalAmount)}
                </Typography.Text>
              </div>
            </Card>
          </Col>
        </Row>
        <div className="pt-4">
          <Row gutter={[16, 16]}>
            <Col
              className="gutter-row"
              span={24}
              xl={{ span: 16 }}
              md={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Card title="Biểu đồ">
                {reportChartOrder && <Column {...config} />}
              </Card>
            </Col>
            <Col
              className="gutter-row"
              span={24}
              xl={{ span: 8 }}
              md={{ span: 24 }}
              xs={{ span: 24 }}
            >
              <Card title="Bán chạy">
                <List className="demo-loadmore-list" itemLayout="horizontal">
                  {bestSellerProduct()}
                </List>
              </Card>
            </Col>
          </Row>
        </div>
      </Content>
    </div>
  );
}
